<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option mgb_5">
				<span class="int_type_no_border mgr_5">
					<em class="lt_text mgr_5">Row By</em>
					<select class="int_type" v-model="row_by" @change="changeGroupBy">
						<option value="VENDOR">Vendor</option>
						<option value="ITEM">Item</option>
						<option value="VENDOR_ITEM">Vendor&Item</option>
						<option value="PO">Purchase Order</option>
						<option :value="null">Purchase Item</option>
					</select>
				</span>

				<span class="int_type_no_border mgr_5 mgl_15">
					<em class="lt_text mgr_5">Subtotal</em>
					<template v-if="group_by_only_item">
						<label class="mgr_5"><input type="radio" value="ITEM_CLASS" v-model="subtotal" /> Item {{ headers.class }}</label>
					</template>
					<template v-if="group_by_vendor_item">
						<label class="mgr_5"><input type="radio" value="VENDOR" v-model="subtotal" /> Vendor</label>
						<label class="mgr_5"><input type="radio" value="ITEM_CLASS" v-model="subtotal" /> Item {{ headers.class }}</label>
					</template>
					<template v-if="group_by_none">
						<label class="mgr_5"><input type="radio" value="PO" v-model="subtotal" /> PO</label>
					</template>
					<template v-if="group_by_po">
						<label class="mgr_5"><input type="radio" value="VENDOR" v-model="subtotal" /> Vendor</label>
					</template>
					<label class="mgr_5"><input type="radio" :value="null" v-model="subtotal" /> None</label>
				</span>

				<span class="int_type_no_border mgr_5 mgl_15">
					<label>
						<em class="lt_text">Record</em>
						<span class="int_type_no_border mgr_5">
							<currency-input type="text" v-model="record_count" :precision="0" class="tbl_int ssm_int al_right" />
						</span>
					</label>
					<label class="mgl_5">
						<em class="lt_text">Order By</em>
						<span class="mgr_5">
							<select class="int_type" v-model="sort_key">
								<option value="quantity">Quantity</option>
								<option value="amount">Amount</option>
							</select>
						</span>
					</label>
					<label class="mgl_5">
						<em class="lt_text">Sort</em>
						<span class="mgr_5">
							<select class="int_type" v-model="sort_direction">
								<option value="DESC">DESC</option>
								<option value="ASC">ASC</option>
							</select>
						</span>
					</label>
				</span>
			</div>

			<div class="left_option mgb_5">
				<span class="int_type_no_border mgr_5">
					<select class="tbl_select" v-model="search_date_type">
						<option value="P">P/O Date</option>
						<option value="S">Arr/ETA Date</option>
						<option value="R">Rcvd. Date</option>
					</select>
				</span>
				<span class="mgr_15">
					<CustomDatePicker v-model="date_from" /> ~
					<CustomDatePicker v-model="date_to" />
				</span>

				<span class="int_type_no_border mgr_5">
					<PartnerSelect ph="Vendor" :showName="false" :vendorOnly="true" v-model="searched_partner" @set-partner="setPartner" />
				</span>
				<span class="int_type mgr_15" style="width:240px;">
					<input type="text" v-model.trim="vendors_string" autocomplete="off" @focus="$event.target.select()" />
				</span>

				<em class="lt_text">P/O Status</em>
				<span class="int_type_no_border mgr_10">
					<select class="tbl_select" v-model="po_status">
						<option value="A">ALL</option>
						<option value="E">Exclude Only on Order</option>
					</select>
				</span>

				<em class="lt_text">Item-Recived</em>
				<span class="int_type_no_border mgr_10">
					<select class="tbl_select" v-model="received_status">
						<option value="A">ALL</option>
						<option value="Y">Received</option>
						<option value="N">Not Received</option>
					</select>
				</span>

				<em class="lt_text">P/O Closed</em>
				<span class="int_type_no_border mgr_10">
					<select class="tbl_select" v-model="po_closed_status">
						<option value="A">ALL</option>
						<option value="Y">Closed</option>
						<option value="N">Not Closed</option>
					</select>
				</span>
			</div>
			<div class="left_option mgb_5">
				<em class="lt_text">Item {{ headers.class }}</em>

				<span class="int_type quarter3_int">
					<AC ref="ac" :disableInput="only_amount" :inputClass="{ bg_disabled: only_amount }" :source="selectClasses" @selected="selectClass" results-display="code_name" placeholder="Item / Class Name or Code"> </AC>
				</span>

				<span class="int_type_no_border mgr_15">
					<ItemClassSelectMulti v-model.trim="item_classes_string" :selectOnClick="false" @keydown="search" :disabled="only_amount" />
				</span>

				<em class="lt_text">Item Color</em>
				<span class="int_type">
					<input type="text" :disabled="only_amount" :class="{ bg_disabled: only_amount }" v-model.trim="colors_string" placeholder="ex) 1, 2, 1B" autocomplete="off" @keyup.enter="search()" @focus="$event.target.select()" />
				</span>
				<span>(Only Applied In Case Of Searching by {{ headers.class }}.)</span>
			</div>
			<div class="left_option mgb_5">
				<span class="int_type_no_border mgr_15">
					<ItemSelectMulti :disabled="only_amount" v-model.trim="selected_items_str" :active_only="false" :separator="separator" :resultsDisplay="obj => obj.item_code + ' | ' + obj.name" />
				</span>

				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>

				<label class="mgl_15">
					<input type="checkbox" v-model="only_amount" :disabled="!group_by_only_vendor" />
					<span>Relates Only to Account.</span>
				</label>
			</div>
		</div>

		<div class="fixed-table-container-none-padding">
			<div class="table-wrapper" style="height: 90%;">
				<CommonTable :tbl_headers="tbl_headers" :data="row_data" @linkPO="linkPO" @linkVendor="linkVendor" />
			</div>
		</div>

		<div class="view_bottom_bt">
			<a href="javascript:void(0);" type="button" class="search_bt mgr_15" @click="exportExcel">Excel</a>
			<span class="int_type" style="width:200px;">
				<input type="text" v-model.trim="user_email" autocomplete="off" placeholder="Email for Async Excel" @focus="$event.target.select()" />
			</span>
			<a href="javascript:void(0);" type="button" class="search_bt" @click="exportAsyncExcel">Async Excel</a>
		</div>
	</div>
</template>

<script>
import CommonTable from '@/components/common/commonTable/CommonTable.vue';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import PartnerSelect from '@/components/common/PartnerSelect';
import ItemClassSelectMulti from '@/components/common/ItemClassSelectMulti';
import ItemSelectMulti from '@/components/common/ItemSelectMulti';
import AC from '@/components/common/AC';

import {
	apiSelectPurchaseOverviewByPurchaseItem,
	apiSelectPurchaseOverviewByPo,
	apiSelectPurchaseOverviewByVendor,
	apiSelectPurchaseOverviewByItem,
	apiSelectPurchaseOverviewByVendorItem,
	apiStreamPurchaseOverviewByPurchaseItem,
} from '@/api/report/report.js';
import { monthAdd, isDate, today, toDate, dateDiff } from '@/utils/date.js';
import { inputSelectOnClick } from '@/utils/etc.js';
import { exportDataExcel } from '@/api/util';
import { defaultDataType } from 'export-xlsx';

export default {
	data: () => ({
		row_by: 'VENDOR',
		subtotal: null,

		record_count: null,
		sort_key: 'amount',
		sort_direction: 'DESC',

		search_date_type: 'P',
		date_from: monthAdd(-3),
		date_to: today(),

		po_status: 'A',
		received_status: 'A',
		po_closed_status: 'A',

		searched_partner: null,
		vendors_string: '',
		item_classes_string: '',
		colors_string: '',
		selected_items_str: '',

		only_amount: false,

		separator: ',',

		row_data: [],
		tbl_headers: [],
		save_param: {},

		user_email: null,
	}),
	components: {
		CommonTable,
		CustomDatePicker,
		PartnerSelect,
		ItemClassSelectMulti,
		ItemSelectMulti,
		AC,
	},
	props: ['headers'],
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		company_id() {
			return this.user ? this.user.company_id : null;
		},
		selected_item_codes() {
			return this.selected_items_str ? this.selected_items_str.split(this.separator) : [];
		},
		vendors() {
			return this.vendors_string ? this.vendors_string.split(this.separator) : [];
		},
		item_classes() {
			return this.item_classes_string ? this.item_classes_string.split(/ |,/) : [];
		},
		colors() {
			return this.colors_string ? this.colors_string.split(this.separator) : [];
		},
		group_by_only_vendor() {
			return this.row_by === 'VENDOR';
		},
		group_by_only_item() {
			return this.row_by === 'ITEM';
		},
		group_by_vendor_item() {
			return this.row_by === 'VENDOR_ITEM';
		},
		group_by_po() {
			return this.row_by === 'PO';
		},
		group_by_none() {
			return !this.row_by;
		},
	},
	methods: {
		reset() {
			this.row_by = 'VENDOR';
			this.subtotal = null;

			this.record_count = null;
			this.sort_key = 'amount';
			this.sort_direction = 'DESC';

			this.search_date_type = 'P';
			this.date_from = monthAdd(-3);
			this.date_to = today();

			this.po_status = 'A';
			this.received_status = 'A';
			this.po_closed_status = 'A';

			this.searched_partner = null;
			this.vendors_string = '';
			this.item_classes_string = '';
			this.colors_string = '';
			this.selected_items_str = '';

			this.only_amount = false;
		},
		setPartner(vendor) {
			if (this.vendors_string) this.vendors_string += this.separator + vendor.code;
			else this.vendors_string = vendor.code;
		},
		selectClasses(input) {
			var url = process.env.VUE_APP_API_URL + '/api/item/item_class/acClassList?company_id=' + this.user.company_id + '&include_closed_yn=Y&keyword=' + input;
			return url;
		},
		selectClass(c) {
			this.$refs.ac.clear();
			if (this.item_classes_string) this.item_classes_string += this.separator + c.selectedObject.code;
			else this.item_classes_string = c.selectedObject.code;
		},
		changeGroupBy() {
			this.subtotal = null;
			if (!this.group_by_only_vendor) {
				this.only_amount = false;
			}
		},
		linkPO(data) {
			const po_no = data.po_no;

			if (!po_no) return;

			let routeData = this.$router.resolve({ name: 'purchaseDetail', params: { mode: 'detail' }, query: { po_no: po_no } });
			window.open(routeData.href, 'herp_purchase');
		},
		linkVendor(data) {
			const vendor_code = data.vendor_code;

			if (!vendor_code) return;

			let routeData = this.$router.resolve({ name: 'partnerDetail', params: { mode: 'detail' }, query: { code: vendor_code } });
			window.open(routeData.href, 'herp_partner');
		},
		async search() {
			if (!this.checkSearchCondition()) return;

			this.makeParam();

			let response = null;
			// Group by Vendor
			if (this.group_by_only_vendor) {
				response = await apiSelectPurchaseOverviewByVendor(this.save_param);
			}
			// Group by Item
			else if (this.group_by_only_item) {
				response = await apiSelectPurchaseOverviewByItem(this.save_param);
			}
			// Group by Vendor & Item
			else if (this.group_by_vendor_item) {
				response = await apiSelectPurchaseOverviewByVendorItem(this.save_param);
			}
			// Group by Purchase Order
			else if (this.group_by_po) {
				response = await apiSelectPurchaseOverviewByPo(this.save_param);
			}
			// Group by None
			else if (this.group_by_none) {
				response = await apiSelectPurchaseOverviewByPurchaseItem(this.save_param);
			}

			if (response) {
				// Total, Subtotal에 배경색 추가
				response.data.forEach(el => {
					if (!el.ranking) {
						el.tr_class = 'bg_gray';
						el.id = 'total';
					}
				});

				this.row_data = response.data;
				this.makeTblHeaders();
			} else {
				this.$toast.error('Network Error.');
			}
		},
		checkSearchCondition() {
			if (!this.date_from || !isDate(this.date_from)) {
				this.$toast.error('Invalid date');
				return false;
			}

			if (!this.date_to || !isDate(this.date_to)) {
				this.$toast.error('Invalid date');
				return false;
			}

			var date_from = toDate(this.date_from);
			var date_to = toDate(this.date_to);

			if (dateDiff(date_from, date_to) > 365) {
				this.$toast.error('Search period exceeds 365 days. Please use "Async Excel" (up to 5 years).');
				return false;
			}

			return true;
		},
		checkAsyncSearchCondition() {
			if (!this.date_from || !isDate(this.date_from)) {
				this.$toast.error('Invalid date');
				return false;
			}

			if (!this.date_to || !isDate(this.date_to)) {
				this.$toast.error('Invalid date');
				return false;
			}

			var date_from = toDate(this.date_from);
			var date_to = toDate(this.date_to);

			if (dateDiff(date_from, date_to) > 365 * 5) {
				this.$toast.error('Maximum search period is 5 years.');
				return false;
			}

			return true;
		},
		makeTblHeaders() {
			// Group by Vendor + Relates Only to Amount
			if (this.group_by_only_vendor && this.only_amount) {
				// Vendor Code, Vendor Name
				// Order Amount, Discount, Order Total, Ship Amount, Received Amount, Balance, PO Count
				this.tbl_headers = [
					{ key: 'vendor_code', name: 'Code', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true, click_event: 'linkVendor' },
					{ key: 'vendor_name', name: 'Vendor Name', width: 20, dataType: defaultDataType.string, tbl_width: '15%', td_class: 'al_left', editable: true, click_event: 'linkVendor' },
					{ key: 'order_fob_amount', name: 'Order FOB', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'order_amount', name: 'Order Amt', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'discount_amount', name: 'Discount', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'total_amount', name: 'Order Total', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'ship_fob_amount', name: 'Ship FOB', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'shipped_amount', name: 'Ship Amt', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'received_amount', name: 'Rcvd Amt', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'balance', name: 'Balance', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'po_cnt', name: 'Order Cnt', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
				];
			}

			// Group by Vendor + Relates Only to Amount X
			if (this.group_by_only_vendor && !this.only_amount) {
				// Vendor Code, Vendor Name
				// Order Quantity, Order FOB, Order Amount, Shipped Quantity, Shipped FOB, Shipped Amount, Received Quantity, Received Amount, PO Count
				this.tbl_headers = [
					{ key: 'vendor_code', name: 'Code', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true, click_event: 'linkVendor' },
					{ key: 'vendor_name', name: 'Vendor Name', width: 20, dataType: defaultDataType.string, tbl_width: '15%', td_class: 'al_left', editable: true, click_event: 'linkVendor' },
					{ key: 'order_quantity', name: 'Order Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
					{ key: 'order_fob_amount', name: 'Order FOB', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'order_amount', name: 'Order Amt', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'shipped_quantity', name: 'Ship Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
					{ key: 'ship_fob_amount', name: 'Ship FOB', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'shipped_amount', name: 'Ship Amt', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'received_quantity', name: 'Rcvd Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
					{ key: 'received_amount', name: 'Rcvd Amt', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'po_cnt', name: 'Order Cnt', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
				];
			}

			// Group by Item
			else if (this.group_by_only_item) {
				// Class Code, Color Code, Item Name,
				// Order Quantity, Order FOB, Order Amount, Shipped Quantity, Shipped FOB, Shipped Amount, Received Quantity, Received Amount
				this.tbl_headers = [
					{ key: 'class_code', name: 'Code', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true },
					{ key: 'color_code', name: 'Color', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true },
					{ key: 'item_name', name: 'Item Name', width: 20, dataType: defaultDataType.string, tbl_width: '15%', td_class: 'al_left', editable: true },
					{ key: 'order_quantity', name: 'Order Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
					{ key: 'order_fob_amount', name: 'Order FOB', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'order_amount', name: 'Order Amt', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'shipped_quantity', name: 'Ship Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
					{ key: 'ship_fob_amount', name: 'Ship FOB', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'shipped_amount', name: 'Ship Amt', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'received_quantity', name: 'Rcvd Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
					{ key: 'received_amount', name: 'Rcvd Amt', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
				];
			}

			// Group by Vendor & Item
			else if (this.group_by_vendor_item) {
				// Vendor Code, Vendor Name, Class Code, Color Code, Item Name,
				// Order Quantity, Order FOB, Order Amount, Shipped Quantity, Shipped FOB, Shipped Amount, Received Quantity, Received Amount
				this.tbl_headers = [
					{ key: 'vendor_code', name: 'Code', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true, click_event: 'linkVendor' },
					{ key: 'vendor_name', name: 'Vendor Name', width: 20, dataType: defaultDataType.string, tbl_width: '15%', td_class: 'al_left', editable: true, click_event: 'linkVendor' },
					{ key: 'class_code', name: 'Code', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true },
					{ key: 'color_code', name: 'Color', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true },
					{ key: 'item_name', name: 'Item Name', width: 20, dataType: defaultDataType.string, tbl_width: '15%', td_class: 'al_left', editable: true },
					{ key: 'order_quantity', name: 'Order Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
					{ key: 'order_fob_amount', name: 'Order FOB', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'order_amount', name: 'Order Amt', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'shipped_quantity', name: 'Ship Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
					{ key: 'ship_fob_amount', name: 'Ship FOB', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'shipped_amount', name: 'Ship Amt', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'received_quantity', name: 'Rcvd Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
					{ key: 'received_amount', name: 'Rcvd Amt', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
				];
			}

			// Group by PO
			else if (this.group_by_po) {
				// PO DN, PO Date, Vendor Code, Vendor Name
				// Order Quantity, Order Amount, Discount, Order Total, Ship Quantity, Ship Amount, Received Quantity, Received Amount, Paid Amount, Balance
				this.tbl_headers = [
					{ key: 'po_dn', name: 'PO', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true, click_event: 'linkPO' },
					{ key: 'po_date', name: 'PO Date', width: 20, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true, display_filter: 'convertYMDToMDY' },
					{ key: 'vendor_code', name: 'Code', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true, click_event: 'linkVendor' },
					{ key: 'vendor_name', name: 'Vendor Name', width: 20, dataType: defaultDataType.string, tbl_width: '15%', td_class: 'al_left', editable: true, click_event: 'linkVendor' },
					{ key: 'order_quantity', name: 'Order Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
					{ key: 'order_amount', name: 'Order Amt', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'discount_amount', name: 'Discount', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'total_amount', name: 'Order Total', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'shipped_quantity', name: 'Ship Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
					{ key: 'shipped_amount', name: 'Ship Amt', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'received_quantity', name: 'Rcvd Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
					{ key: 'received_amount', name: 'Rcvd Amt', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'paid_amount', name: 'Paid Amt', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'balance', name: 'Balance', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
				];
			}

			// Group by None
			else if (this.group_by_none) {
				// PO DN, PO Date, Vendor Code, Vendor Name, Class Code, Color Code, Item Name,
				// Order Quantity, Order FOB, Order Amount, Shipped Quantity, Shipped FOB, Shipped Amount, Received Quantity, Received Amount
				this.tbl_headers = [
					{ key: 'po_dn', name: 'PO', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true, click_event: 'linkPO' },
					{ key: 'po_date', name: 'PO Date', width: 20, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true, display_filter: 'convertYMDToMDY' },
					{ key: 'vendor_code', name: 'Code', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true, click_event: 'linkVendor' },
					{ key: 'vendor_name', name: 'Vendor Name', width: 20, dataType: defaultDataType.string, tbl_width: '15%', td_class: 'al_left', editable: true, click_event: 'linkVendor' },
					{ key: 'class_code', name: 'Code', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true },
					{ key: 'color_code', name: 'Color', width: 15, dataType: defaultDataType.string, tbl_width: '6%', td_class: 'al_center', editable: true },
					{ key: 'item_name', name: 'Item Name', width: 20, dataType: defaultDataType.string, tbl_width: '15%', td_class: 'al_left', editable: true },
					{ key: 'order_quantity', name: 'Order Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
					{ key: 'order_fob_amount', name: 'Order FOB', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'order_amount', name: 'Order Amt', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'shipped_quantity', name: 'Ship Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
					{ key: 'ship_fob_amount', name: 'Ship FOB', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'shipped_amount', name: 'Ship Amt', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
					{ key: 'received_quantity', name: 'Rcvd Qty', width: 10, dataType: defaultDataType.currency, tbl_width: '4%', td_class: 'al_right', display_filter: 'commaSeparated' },
					{ key: 'received_amount', name: 'Rcvd Amt', width: 15, dataType: defaultDataType.number, tbl_width: '6%', td_class: 'al_right', display_filter: 'toCurrency' },
				];
			}
		},
		makeParam() {
			this.save_param = {
				sort_key: this.sort_key,
				sort_direction: this.sort_direction,
				limit_yn: this.record_count ? 'Y' : 'N',
				start_index: 0,
				limit_size: this.record_count,
				subtotal: this.subtotal,
				po_status: this.po_status,
				received_status: this.received_status,
				po_closed_status: this.po_closed_status,
				search_date_type: this.search_date_type,
				date_from: this.date_from,
				date_to: this.date_to,
				item_classes: this.item_classes,
				item_codes: this.selected_item_codes,
				color_codes: this.colors,
				vendors: this.vendors,
			};

			if (this.only_amount) {
				this.$toast.info('Search by Excluding Item Search Criteria.');

				this.save_param.item_classes = null;
				this.save_param.item_codes = null;
				this.save_param.color_codes = null;
			}
		},
		async exportExcel() {
			exportDataExcel(this.row_data, this.tbl_headers, 'PurchaseOverview');
		},
		async exportAsyncExcel() {
			if (!this.user_email) {
				this.$toast.error('Email is empty');
				return false;
			}

			if (!this.checkAsyncSearchCondition()) return;

			const ok = window.confirm("This request will be processed in tonight's batch (around 2:00 AM) and the result will be emailed to " + this.user_email + '.\n\nUp to 5 pending requests per company are allowed.\n\nProceed?');
			if (!ok) return;

			this.makeParam();

			const asyncParam = { ...this.save_param, user_email: this.user_email };

			try {
				const result = await apiStreamPurchaseOverviewByPurchaseItem(asyncParam);
				if (result.status == 202) {
					this.$toast.success(result.data.message);
				} else {
					this.$toast.error(result.data && result.data.message ? result.data.message : result.statusText);
				}
			} catch (err) {
				const msg = err.response && err.response.data && err.response.data.message ? err.response.data.message : 'Failed to queue the report request';
				this.$toast.error(msg);
			}
		},
	},
	mounted() {
		inputSelectOnClick();
		if (this.user) {
			this.user_email = this.user.email;
			if (!this.user_email) this.$toast.info('The default email address for "Async Excel" can be configured under User Settings.');
		}
	},
	created() {
		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_purchase_overview');
		this.$store.commit('setSubTitle', 'Report -> Purchase Overview');
	},
};
</script>
